var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModalDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF5959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5706_4445",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5706_4445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14.0664V6.5H12.3889V14.0664H11ZM11 17.8496V16.4985H12.3889V17.8496H11Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalDelete);
export default __webpack_public_path__ + "static/media/icon_modal-delete.73780c8a96718ec1fad8fb9e7cff89b3.svg";
export { ForwardRef as ReactComponent };